/* eslint-disable react/jsx-no-undef */
import * as React from "react";
import {
    IGenericUserProps,
    genericMapStateToProps,
} from "../../../DataClasses/GenericUser";
import { Theme, createStyles, } from '@mui/material/styles';;
import { WithStyles, withStyles } from '@mui/styles';;
import idssStyle from "../../../Configuration/SharedStyling";
import { connect } from "react-redux";
import { Grid2 as Grid, Paper, Button, Tooltip, IconButton, Link, Dialog, DialogTitle, Divider, DialogContent, DialogActions } from "@mui/material";
import { AddCircle, Delete } from "@mui/icons-material";
import MuiAlert from "@mui/material/Alert";
import SharedMaterialReactTable, { ISharedTableColumn } from "../../Shared/MaterialReactTable";
import { firstValueFrom } from "rxjs";
import AdministrationService from "../../Services/AdministrationService";
import { ITestOrgConfig } from "../../../DataClasses/TestOrgConfig";
import AlertDialog from "../../Shared/AlertDialog";
import { AjaxError } from "rxjs/ajax";
import Select from "react-select";
import LoadingDataTable from '../../Shared/LoadingDataTable';


const styles = (theme: Theme) => createStyles({
    ...idssStyle(theme),
    paperStyle: {
        flexGrow: 0,
        padding: theme.spacing(2, 2),
        width: "55%"
    }
});
interface ITestOrgsConfigStateStore {
    isLoading: boolean;
    inputOrgIds: string;
    tableData: any[];
    showTable: boolean;
    redirect: boolean;
    addSuccess: boolean;
    isDeleting: boolean;
    deletingOrgId: number;
    orgIdsCsvByMYDialogOpen: boolean;
    selectedMy: number;
    orgIdsCsv: string;
}


interface LocalProps {
    measurementYear: number
}

type Props = LocalProps & WithStyles<typeof styles>;

class TestOrgsConfigView extends React.Component<
    IGenericUserProps & Props,
    ITestOrgsConfigStateStore
> {
    constructor(props: any) {
        super(props);
        this.state = {
            isLoading: false,
            inputOrgIds: "",
            tableData: [],
            showTable: false,
            redirect: false,
            addSuccess: false,
            isDeleting: false,
            deletingOrgId: -1,
            orgIdsCsvByMYDialogOpen: false,
            selectedMy: -1,
            orgIdsCsv: ""
        }
    }

    public componentDidMount() {
        this.refreshModel();
    }

    private setRedirectState() {
        this.setState({ redirect: true });
    }

    private renderDeleteButton = (rowData: any) => {
        return (
            <Tooltip title="Delete Test Org Config" aria-label="Delete">
                <IconButton size='medium' onClick={() => this.ShowDeleteTestOrgDialog(rowData.orgId)} disabled={this.state.isDeleting}>
                    <Delete fontSize="inherit"></Delete>
                </IconButton >
            </Tooltip>
        );
    }

    public render() {
        const { classes } = this.props;
        let deleteAlertDiscription = "Are you sure you want to delete this Test Org Config (OrgID: " + this.state.deletingOrgId + ")?";
        const myOptions = this.getMyOptions();

        const showOrgName = this.state.tableData.length > 0 && this.state.tableData[0].isFromProdDw;
        const header = `Configuration of Test Orgs for MY${this.props.measurementYear}`;

        // Column definitions for SharedMaterialReactTable
        const getTestOrgsColumns = (): ISharedTableColumn<any>[] => {
            const columns = [
                {
                    accessorKey: 'orgId' as any,
                    header: 'OrgId',
                    enableSorting: true,
                    enableFiltering: true,
                },
                {
                    accessorKey: 'createdBy' as any,
                    header: 'CreatedBy',
                    enableSorting: true,
                    enableFiltering: true,
                },
                {
                    accessorKey: 'createdOn' as any,
                    header: 'CreatedOn',
                    enableSorting: true,
                    enableFiltering: true,
                },
                {
                    accessorKey: 'delete' as any,
                    header: 'Delete',
                    enableSorting: false,
                    enableFiltering: false,
                    enableColumnActions: false,
                    Cell: ({ row }) => this.renderDeleteButton(row.original),
                },
            ];

            // Add orgName column conditionally
            if (showOrgName) {
                columns.splice(1, 0, {
                    accessorKey: 'orgName' as any,
                    header: 'OrgName',
                    enableSorting: true,
                    enableFiltering: true,
                });
            }

            return columns;
        };

        return (
            <div>
                <Paper className={classes.paperStyle} >
                    <Grid container spacing={1}>
                        <Grid size={9}>
                            OrgId(s): &nbsp;&nbsp;
                            <input
                                type="text"
                                value={this.state.inputOrgIds}
                                onChange={this.handleinputOrgIdsChange}
                                style={{ width: '430px', height: '35px' }}
                                placeholder="Enter a single OrgId or OrgId(s) separated by comma (e.g: 123,456)"
                            />
                            &nbsp;&nbsp;
                            <Tooltip title="Enable me by entering a single OrgId or multiple OrgIds separated by commas." disableHoverListener={this.IsInputOrgIdsValid()}>
                                <span>
                                    <Button variant='contained' color='secondary' onClick={async () => {
                                        await this.addTestOrgs()
                                    }} className={classes.button} startIcon={<AddCircle />} disabled={!this.IsInputOrgIdsValid()}>
                                        Add Test Orgs
                                    </Button>
                                </span>
                            </Tooltip>
                        </Grid>
                        <Grid size={3} >
                            {this.state.addSuccess ?
                                <MuiAlert elevation={6} variant="filled" >Successfully Added.</MuiAlert>
                                :
                                <Link
                                    component="button"
                                    onClick={() => this.csvDialogOpen()}
                                >
                                    Get OrgIds CSV By MY
                                </Link>
                            }
                        </Grid>
                        {this.state.tableData.length > 0 && !this.state.tableData[0].isFromProdDw &&
                            <Grid size={12}>
                                <label className="text-muted">
                                    * Note: Even in the staging environment, the list of test OrgIds below should reflect the test OrgIds from production. These will be referenced during the HDF data extract.
                                </label>
                            </Grid>
                        }
                        {this.state.isLoading ?
                            <LoadingDataTable titleText={"*"} />
                            :
                            <Grid size={12}>
                                <SharedMaterialReactTable
                                    data={this.state.tableData}
                                    columns={getTestOrgsColumns()}
                                    title={header}
                                    isLoading={this.state.isLoading}
                                    enablePagination={true}
                                    enableSorting={true}
                                    enableFiltering={true}
                                    enableColumnActions={true}
                                    enableRowActions={false}
                                    layoutMode="fixed"
                                    initialState={{
                                        pagination: { pageIndex: 0, pageSize: 25 },
                                    }}
                                    muiPaginationProps={{
                                        rowsPerPageOptions: [10, 15, 20, 25, 50, 75, 100],
                                    }}
                                    emptyMessage="No test org configs found."
                                />
                            </Grid>
                        }
                        <AlertDialog
                            showDialog={this.state.deletingOrgId > -1}
                            title="Delete Test Org Config"
                            description={deleteAlertDiscription}
                            button1Text="Delete"
                            button2Text="Cancel"
                            button1Handler={this.deleteTestOrgConfig}
                            button2Handler={() => this.CloseDeleteTestOrgConfigDialog()}
                            isButton1Clicked={this.state.isDeleting}
                        />
                        <Dialog open={this.state.orgIdsCsvByMYDialogOpen} onClose={() => this.csvDialogClose()} classes={{ paper: classes.dialogS }}>
                            <DialogTitle id="max-width-dialog-title">
                                Get OrgIDs Csv By MeasurementYear
                            </DialogTitle>
                            <Divider />
                            <DialogContent>
                                Select Measurement Year:
                                <Select
                                    options={myOptions}
                                    placeholder="Select MeasurementYear"
                                    isMulti={false}
                                    value={{ value: this.state.selectedMy, label: `${this.state.selectedMy}` }}
                                    closeMenuOnSelect={false}
                                    isSearchable={true}
                                    onChange={this.selectedMyChange.bind(this)}
                                    menuPortalTarget={document.body}
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                />
                                <br />
                                <br />
                                OrgIDs CSV: <br /> <br />
                                {this.state.orgIdsCsv}
                            </DialogContent>
                            <Divider />
                            <DialogActions>
                                <Button
                                    onClick={() => this.csvDialogClose()}
                                >
                                    ClOSE
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </Grid>
                </Paper>
            </div>
        );
    }
    private csvDialogClose() {
        this.setState({
            selectedMy: this.props.measurementYear,
            orgIdsCsv: "",
            orgIdsCsvByMYDialogOpen: false
        });
    }
    private csvDialogOpen() {
        let csv = this.state.tableData.map(x => x.orgId.toString()).join(",");
        this.setState({
            selectedMy: this.props.measurementYear,
            orgIdsCsv: csv,
            orgIdsCsvByMYDialogOpen: true
        });
    }
    private async selectedMyChange(my: any) {
        const retval: ITestOrgConfig[] = await firstValueFrom(
            AdministrationService.GetTestOrgsConfig$(this.props.user, my.value)
        );
        if (retval instanceof AjaxError || !retval) {
            this.setRedirectState();
        }
        else {
            let csv = retval.map(x => x.orgId.toString()).join(",");
            this.setState({ selectedMy: my.value, orgIdsCsv: csv });
        }
    }
    private getMyOptions() {
        type myPair = {
            value: number;
            label: string;
        }
        const startMy = 2015;
        const myPairs: myPair[] = [];
        for (let my = this.props.measurementYear; my >= startMy; my--) {
            myPairs.push({ value: my, label: `${my}` });
        }
        return myPairs;
    }
    private ShowDeleteTestOrgDialog = (orgId) => {
        this.setState({ deletingOrgId: orgId });
    }
    private CloseDeleteTestOrgConfigDialog = () => {
        this.setState({ deletingOrgId: -1 });
    }

    private deleteTestOrgConfig = async () => {
        this.setState({ isDeleting: true });
        const orgId = this.state.deletingOrgId;
        const retval = await firstValueFrom(AdministrationService.DeleteTestOrgConfig$(this.props.user, orgId));
        if (retval instanceof AjaxError || !retval) {
            this.setRedirectState();
        }
        else {
            await this.loadTableData();
            this.setState({ isDeleting: false, deletingOrgId: -1 });
        }
    }
    private addTestOrgs = async () => {
        const retval = await firstValueFrom(AdministrationService.AddTestOrgsConfig$(this.props.user, this.state.inputOrgIds));
        if (retval instanceof AjaxError || !retval) {
            this.setRedirectState();
        }
        await this.refreshModel();
        this.setState({ addSuccess: true, inputOrgIds: "" });
        setTimeout(() => {
            this.setState({ addSuccess: false });
        }, 4000);
    }
    private IsInputOrgIdsValid = () => {
        // single positive integer or comma separated positive integers
        const regex = /^\d+(,\d+)*$/;
        return regex.test(this.state.inputOrgIds);
    }
    private handleinputOrgIdsChange = (e: any) => {
        this.setState({ inputOrgIds: e.target.value });
    }

    private async refreshModel() {
        this.setState({ isLoading: true });
        await this.loadTableData();
        this.setState({ selectedMy: this.props.measurementYear, isLoading: false });
    }

    private async loadTableData() {
        const retval: ITestOrgConfig[] = await firstValueFrom(
            AdministrationService.GetTestOrgsConfig$(this.props.user, this.props.measurementYear)
        );
        if (retval instanceof AjaxError || !retval) {
            this.setRedirectState();
        }
        else {
            this.setState({
                tableData: retval
            });
        }
    }

}

const TestOrgsConfigPageWithState = connect<IGenericUserProps>(
    genericMapStateToProps
)(TestOrgsConfigView);

// STYLES CONTAINER
const TestOrgsConfigPage = withStyles(styles)(
    TestOrgsConfigPageWithState
);

export default TestOrgsConfigPage;
